import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  OnChanges,
  OnDestroy,
  Renderer2,
  SimpleChanges,
} from "@angular/core";
import { INDRAIbeAdminService } from "../../services/ibeadmin.indra.service";
import { Subscription } from "rxjs";

@Directive({
    selector: "[skeletonLoader]",
})
export class SkeletonLoaderDirective implements OnInit, OnChanges, OnDestroy {
    @Input("translationKey") translationKey?: string;

    private keyLoadingSubscription: Subscription;
    private loaderKey: string;
    private timer: any;
    private isMin: boolean = true;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private ibeAdminService: INDRAIbeAdminService
    ) {}

    ngOnInit(): void {
        this.loaderKey = this.translationKey;

        if (this.loaderKey) {
            this.keyLoadingSubscription = this.ibeAdminService
                .getLoadingState(this.loaderKey)
                .subscribe((isLoading: boolean) => {
                    if (isLoading) {
                        this.renderer.addClass(this.el.nativeElement, "skeleton");
                        this.animatePlaceholder();
                    } else {
                        this.removePlaceholderAnimation();
                        this.renderer.removeClass(this.el.nativeElement, "skeleton");
                    }
                });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['translationKey'] && changes['translationKey'].currentValue) {
            this.loaderKey = this.translationKey;
            if (this.loaderKey) {
                
                this.keyLoadingSubscription = this.ibeAdminService
                    .getLoadingState(this.loaderKey)
                    .subscribe((isLoading: boolean) => {
                        if (isLoading) {
                            this.renderer.addClass(this.el.nativeElement, "skeleton");
                            this.animatePlaceholder();
                        } else {
                            this.removePlaceholderAnimation();
                            this.renderer.removeClass(this.el.nativeElement, "skeleton");
                        }
                    });
            }
        }
    }

    animatePlaceholder() {
        if (this.timer) {
            return;
        }

        if (
            this.el.nativeElement.tagName === 'INPUT'
            || this.el.nativeElement.tagName === 'SELECT'
        ) {
            this.isMin = false;

            this.timer = setInterval(() => {
                if (this.isMin) {
                    this.renderer.addClass(this.el.nativeElement, "skeleton-max");
                } else {
                    this.renderer.removeClass(this.el.nativeElement, "skeleton-max");
                }

                this.isMin = !this.isMin;
            }, 1000);
        }
    }

    removePlaceholderAnimation() {
        if (this.timer) {
            clearInterval(this.timer);
            this.isMin = true;
        }

        this.renderer.removeClass(this.el.nativeElement, "skeleton-max");
    }

    ngOnDestroy(): void {
        if (this.keyLoadingSubscription) {
            this.keyLoadingSubscription.unsubscribe();
        }

        if (this.timer) {
            clearInterval(this.timer);
        }
    }
}
